// Version : 0.0.1
// Author : NANDHA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:25-09-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import BranchCollectionReportActionTypes from './branch-collection-report.type';
import { branchCollectionReportListGet } from './branch-collection-report.service';
import {
	getBranchCollectionReportDetailsSuccess,
	getBranchCollectionReportDetailsFailure,
	getBranchCollectionReportDetailsResponseChanged,
} from './branch-collection-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** ***************  START GET BRANCH COLLECTION REPORT DETAILS  ************** */
export function* getBranchCollectionReportList({ payload }: any) {
	try {
		const key = 'GetBranchCollectionReportKey';
		const jsonData = {
			CompanyID: payload.companyID,
			BranchID: payload.branchID,
			DatabaseName: payload.databaseName,
			FromDate: payload.fromDate,
			ToDate: payload.toDate,
			userID: payload.userID,
			userlevel: payload.userLevel,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(branchCollectionReportListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchCollectionReportDetailsFailure(responseData.data));
		} else {
			yield put(getBranchCollectionReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchCollectionReportDetailsFailure(error));
	}
}

export function* resetgetBranchCollectionReportListResponse() {
	yield put(getBranchCollectionReportDetailsResponseChanged());
}

export function* onGetBranchCollectionReportListDetails() {
	yield takeLatest(
		BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_START,
		getBranchCollectionReportList,
	);
}

export function* onGetBranchCollectionReportListResponseReset() {
	yield takeLatest(
		BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_RESPONSE_RESET,
		resetgetBranchCollectionReportListResponse,
	);
}
/** **************  END GET BRANCH COLLECTION REPORT DETAILS *************** */

export function* branchCollectionReportSaga() {
	yield all([
		call(onGetBranchCollectionReportListDetails),
		call(onGetBranchCollectionReportListResponseReset),
	]);
}
